import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from 'src/app/_services';
import { Router,} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

declare const $ : any ;


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit{

  constructor(
    private headerService: HeaderService,
    public router : Router,
    public titles : Title,
    public translate : TranslateService
  ) {
    this.headerService.setHeader(false,false,true,true);
   }

  ngOnInit() {
    this.translate.get('USER_TITLE').subscribe(translation =>{
      this.titles.setTitle(translation);
    });
  }

  ngAfterViewChecked(){
    $(document).trigger('equalizeBox');
  }

}
